import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { ISelectComponentControlProps } from './types';
import { SelectComponent } from '../SelectComponent/SelectComponent';

export const SelectComponentControl = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  ...restProps
}: UseControllerProps<T> & ISelectComponentControlProps) => {
  const { field } = useController({
    name,
    control,
    defaultValue,
  });

  const { ref, value, ...restField } = field;

  return <SelectComponent inputRef={ref} value={value ?? ''} {...restField} {...restProps} />;
};
